import React from 'react';
import OurCollection from '../components/collection/OurCollection';
import CustomiseSection from '../components/collection/CustomiseSection';

const Collection = () => {
    return (
        <div>
            <OurCollection />
            <CustomiseSection />
        </div>
    );
};

export default Collection;
